/**
 * Generated by the protoc-gen-ts.  DO NOT EDIT!
 * compiler version: 7.34.1
 * source: plans/plan.proto
 * git: https://github.com/thesayyn/protoc-gen-ts */
import * as dependency_1 from "./../common/price";
import * as dependency_2 from "./../google/protobuf/timestamp";
import * as dependency_3 from "./../products/model";
import * as pb_1 from "google-protobuf";
import * as grpc_1 from "@grpc/grpc-js";
import * as grpc_web_1 from "grpc-web";
export namespace plans.v1 {
    export enum Type {
        TYPE_UNSPECIFIED = 0,
        TYPE_COMPANY = 1,
        TYPE_PHYSICAL = 2
    }
    export enum Cycle {
        CYCLE_UNSPECIFIED = 0,
        CYCLE_WEEKLY = 1,
        CYCLE_BIWEEKLY = 2,
        CYCLE_MONTHLY = 3,
        CYCLE_YEARLY = 4,
        CYCLE_BIENNIAL = 5,
        CYCLE_SEMIANNUAL = 6,
        CYCLE_EVERY_FOUR_MONTHS = 7
    }
    export enum Status {
        STATUS_UNSPECIFIED = 0,
        STATUS_DRAFT = 1,
        STATUS_PUBLISHED = 2,
        STATUS_ARCHIVED = 3
    }
    export enum Visibility {
        VISIBILITY_UNSPECIFIED = 0,
        VISIBILITY_PUBLIC = 1,
        VISIBILITY_PRIVATE = 2
    }
    export class Resource extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            resourceId?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("resourceId" in data && data.resourceId != undefined) {
                    this.resourceId = data.resourceId;
                }
            }
        }
        get resourceId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set resourceId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            resourceId?: string;
        }): Resource {
            const message = new Resource({});
            if (data.resourceId != null) {
                message.resourceId = data.resourceId;
            }
            return message;
        }
        toObject() {
            const data: {
                resourceId?: string;
            } = {};
            if (this.resourceId != null) {
                data.resourceId = this.resourceId;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.resourceId.length)
                writer.writeString(1, this.resourceId);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): Resource {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new Resource();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.resourceId = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): Resource {
            return Resource.deserialize(bytes);
        }
    }
    export class PlanProduct extends pb_1.Message {
        #one_of_decls: number[][] = [[4]];
        constructor(data?: any[] | ({
            productId?: string;
            name?: string;
            description?: string;
            isActive?: boolean;
            productType?: dependency_3.products.v1.ProductType;
            resources?: Resource[];
        } & (({
            rules?: Rule;
        })))) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [7], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("productId" in data && data.productId != undefined) {
                    this.productId = data.productId;
                }
                if ("name" in data && data.name != undefined) {
                    this.name = data.name;
                }
                if ("description" in data && data.description != undefined) {
                    this.description = data.description;
                }
                if ("rules" in data && data.rules != undefined) {
                    this.rules = data.rules;
                }
                if ("isActive" in data && data.isActive != undefined) {
                    this.isActive = data.isActive;
                }
                if ("productType" in data && data.productType != undefined) {
                    this.productType = data.productType;
                }
                if ("resources" in data && data.resources != undefined) {
                    this.resources = data.resources;
                }
            }
        }
        get productId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set productId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get name() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set name(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get description() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set description(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get rules() {
            return pb_1.Message.getWrapperField(this, Rule, 4) as Rule;
        }
        set rules(value: Rule) {
            pb_1.Message.setOneofWrapperField(this, 4, this.#one_of_decls[0], value);
        }
        get hasRules() {
            return pb_1.Message.getField(this, 4) != null;
        }
        get isActive() {
            return pb_1.Message.getFieldWithDefault(this, 5, false) as boolean;
        }
        set isActive(value: boolean) {
            pb_1.Message.setField(this, 5, value);
        }
        get productType() {
            return pb_1.Message.getFieldWithDefault(this, 6, dependency_3.products.v1.ProductType.PRODUCT_TYPE_UNSPECIFIED) as dependency_3.products.v1.ProductType;
        }
        set productType(value: dependency_3.products.v1.ProductType) {
            pb_1.Message.setField(this, 6, value);
        }
        get resources() {
            return pb_1.Message.getRepeatedWrapperField(this, Resource, 7) as Resource[];
        }
        set resources(value: Resource[]) {
            pb_1.Message.setRepeatedWrapperField(this, 7, value);
        }
        get _rules() {
            const cases: {
                [index: number]: "none" | "rules";
            } = {
                0: "none",
                4: "rules"
            };
            return cases[pb_1.Message.computeOneofCase(this, [4])];
        }
        static fromObject(data: {
            productId?: string;
            name?: string;
            description?: string;
            rules?: ReturnType<typeof Rule.prototype.toObject>;
            isActive?: boolean;
            productType?: dependency_3.products.v1.ProductType;
            resources?: ReturnType<typeof Resource.prototype.toObject>[];
        }): PlanProduct {
            const message = new PlanProduct({});
            if (data.productId != null) {
                message.productId = data.productId;
            }
            if (data.name != null) {
                message.name = data.name;
            }
            if (data.description != null) {
                message.description = data.description;
            }
            if (data.rules != null) {
                message.rules = Rule.fromObject(data.rules);
            }
            if (data.isActive != null) {
                message.isActive = data.isActive;
            }
            if (data.productType != null) {
                message.productType = data.productType;
            }
            if (data.resources != null) {
                message.resources = data.resources.map(item => Resource.fromObject(item));
            }
            return message;
        }
        toObject() {
            const data: {
                productId?: string;
                name?: string;
                description?: string;
                rules?: ReturnType<typeof Rule.prototype.toObject>;
                isActive?: boolean;
                productType?: dependency_3.products.v1.ProductType;
                resources?: ReturnType<typeof Resource.prototype.toObject>[];
            } = {};
            if (this.productId != null) {
                data.productId = this.productId;
            }
            if (this.name != null) {
                data.name = this.name;
            }
            if (this.description != null) {
                data.description = this.description;
            }
            if (this.rules != null) {
                data.rules = this.rules.toObject();
            }
            if (this.isActive != null) {
                data.isActive = this.isActive;
            }
            if (this.productType != null) {
                data.productType = this.productType;
            }
            if (this.resources != null) {
                data.resources = this.resources.map((item: Resource) => item.toObject());
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.productId.length)
                writer.writeString(1, this.productId);
            if (this.name.length)
                writer.writeString(2, this.name);
            if (this.description.length)
                writer.writeString(3, this.description);
            if (this.hasRules)
                writer.writeMessage(4, this.rules, () => this.rules.serialize(writer));
            if (this.isActive != false)
                writer.writeBool(5, this.isActive);
            if (this.productType != dependency_3.products.v1.ProductType.PRODUCT_TYPE_UNSPECIFIED)
                writer.writeEnum(6, this.productType);
            if (this.resources.length)
                writer.writeRepeatedMessage(7, this.resources, (item: Resource) => item.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): PlanProduct {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new PlanProduct();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.productId = reader.readString();
                        break;
                    case 2:
                        message.name = reader.readString();
                        break;
                    case 3:
                        message.description = reader.readString();
                        break;
                    case 4:
                        reader.readMessage(message.rules, () => message.rules = Rule.deserialize(reader));
                        break;
                    case 5:
                        message.isActive = reader.readBool();
                        break;
                    case 6:
                        message.productType = reader.readEnum();
                        break;
                    case 7:
                        reader.readMessage(message.resources, () => pb_1.Message.addToRepeatedWrapperField(message, 7, Resource.deserialize(reader), Resource));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): PlanProduct {
            return PlanProduct.deserialize(bytes);
        }
    }
    export class Plan extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            id?: string;
            organizationId?: string;
            name?: string;
            description?: string;
            price?: dependency_1.common.v1.Price;
            cycle?: Cycle;
            status?: Status;
            visibility?: Visibility;
            products?: PlanProduct[];
            paymentMethods?: PaymentMethod;
            autoRenewal?: boolean;
            maxChargeAttempts?: number;
            overdueDays?: number;
            createdAt?: dependency_2.google.protobuf.Timestamp;
            updatedAt?: dependency_2.google.protobuf.Timestamp;
            trialDays?: number;
            mainAction?: boolean;
            planType?: Type;
            maxUsers?: number;
            removeAds?: boolean;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [9], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("id" in data && data.id != undefined) {
                    this.id = data.id;
                }
                if ("organizationId" in data && data.organizationId != undefined) {
                    this.organizationId = data.organizationId;
                }
                if ("name" in data && data.name != undefined) {
                    this.name = data.name;
                }
                if ("description" in data && data.description != undefined) {
                    this.description = data.description;
                }
                if ("price" in data && data.price != undefined) {
                    this.price = data.price;
                }
                if ("cycle" in data && data.cycle != undefined) {
                    this.cycle = data.cycle;
                }
                if ("status" in data && data.status != undefined) {
                    this.status = data.status;
                }
                if ("visibility" in data && data.visibility != undefined) {
                    this.visibility = data.visibility;
                }
                if ("products" in data && data.products != undefined) {
                    this.products = data.products;
                }
                if ("paymentMethods" in data && data.paymentMethods != undefined) {
                    this.paymentMethods = data.paymentMethods;
                }
                if ("autoRenewal" in data && data.autoRenewal != undefined) {
                    this.autoRenewal = data.autoRenewal;
                }
                if ("maxChargeAttempts" in data && data.maxChargeAttempts != undefined) {
                    this.maxChargeAttempts = data.maxChargeAttempts;
                }
                if ("overdueDays" in data && data.overdueDays != undefined) {
                    this.overdueDays = data.overdueDays;
                }
                if ("createdAt" in data && data.createdAt != undefined) {
                    this.createdAt = data.createdAt;
                }
                if ("updatedAt" in data && data.updatedAt != undefined) {
                    this.updatedAt = data.updatedAt;
                }
                if ("trialDays" in data && data.trialDays != undefined) {
                    this.trialDays = data.trialDays;
                }
                if ("mainAction" in data && data.mainAction != undefined) {
                    this.mainAction = data.mainAction;
                }
                if ("planType" in data && data.planType != undefined) {
                    this.planType = data.planType;
                }
                if ("maxUsers" in data && data.maxUsers != undefined) {
                    this.maxUsers = data.maxUsers;
                }
                if ("removeAds" in data && data.removeAds != undefined) {
                    this.removeAds = data.removeAds;
                }
            }
        }
        get id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get organizationId() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set organizationId(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get name() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set name(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get description() {
            return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
        }
        set description(value: string) {
            pb_1.Message.setField(this, 4, value);
        }
        get price() {
            return pb_1.Message.getWrapperField(this, dependency_1.common.v1.Price, 5) as dependency_1.common.v1.Price;
        }
        set price(value: dependency_1.common.v1.Price) {
            pb_1.Message.setWrapperField(this, 5, value);
        }
        get hasPrice() {
            return pb_1.Message.getField(this, 5) != null;
        }
        get cycle() {
            return pb_1.Message.getFieldWithDefault(this, 6, Cycle.CYCLE_UNSPECIFIED) as Cycle;
        }
        set cycle(value: Cycle) {
            pb_1.Message.setField(this, 6, value);
        }
        get status() {
            return pb_1.Message.getFieldWithDefault(this, 7, Status.STATUS_UNSPECIFIED) as Status;
        }
        set status(value: Status) {
            pb_1.Message.setField(this, 7, value);
        }
        get visibility() {
            return pb_1.Message.getFieldWithDefault(this, 8, Visibility.VISIBILITY_UNSPECIFIED) as Visibility;
        }
        set visibility(value: Visibility) {
            pb_1.Message.setField(this, 8, value);
        }
        get products() {
            return pb_1.Message.getRepeatedWrapperField(this, PlanProduct, 9) as PlanProduct[];
        }
        set products(value: PlanProduct[]) {
            pb_1.Message.setRepeatedWrapperField(this, 9, value);
        }
        get paymentMethods() {
            return pb_1.Message.getWrapperField(this, PaymentMethod, 10) as PaymentMethod;
        }
        set paymentMethods(value: PaymentMethod) {
            pb_1.Message.setWrapperField(this, 10, value);
        }
        get hasPaymentMethods() {
            return pb_1.Message.getField(this, 10) != null;
        }
        get autoRenewal() {
            return pb_1.Message.getFieldWithDefault(this, 11, false) as boolean;
        }
        set autoRenewal(value: boolean) {
            pb_1.Message.setField(this, 11, value);
        }
        get maxChargeAttempts() {
            return pb_1.Message.getFieldWithDefault(this, 12, 0) as number;
        }
        set maxChargeAttempts(value: number) {
            pb_1.Message.setField(this, 12, value);
        }
        get overdueDays() {
            return pb_1.Message.getFieldWithDefault(this, 13, 0) as number;
        }
        set overdueDays(value: number) {
            pb_1.Message.setField(this, 13, value);
        }
        get createdAt() {
            return pb_1.Message.getWrapperField(this, dependency_2.google.protobuf.Timestamp, 14) as dependency_2.google.protobuf.Timestamp;
        }
        set createdAt(value: dependency_2.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 14, value);
        }
        get hasCreatedAt() {
            return pb_1.Message.getField(this, 14) != null;
        }
        get updatedAt() {
            return pb_1.Message.getWrapperField(this, dependency_2.google.protobuf.Timestamp, 15) as dependency_2.google.protobuf.Timestamp;
        }
        set updatedAt(value: dependency_2.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 15, value);
        }
        get hasUpdatedAt() {
            return pb_1.Message.getField(this, 15) != null;
        }
        get trialDays() {
            return pb_1.Message.getFieldWithDefault(this, 16, 0) as number;
        }
        set trialDays(value: number) {
            pb_1.Message.setField(this, 16, value);
        }
        get mainAction() {
            return pb_1.Message.getFieldWithDefault(this, 17, false) as boolean;
        }
        set mainAction(value: boolean) {
            pb_1.Message.setField(this, 17, value);
        }
        get planType() {
            return pb_1.Message.getFieldWithDefault(this, 18, Type.TYPE_UNSPECIFIED) as Type;
        }
        set planType(value: Type) {
            pb_1.Message.setField(this, 18, value);
        }
        get maxUsers() {
            return pb_1.Message.getFieldWithDefault(this, 19, 0) as number;
        }
        set maxUsers(value: number) {
            pb_1.Message.setField(this, 19, value);
        }
        get removeAds() {
            return pb_1.Message.getFieldWithDefault(this, 20, false) as boolean;
        }
        set removeAds(value: boolean) {
            pb_1.Message.setField(this, 20, value);
        }
        static fromObject(data: {
            id?: string;
            organizationId?: string;
            name?: string;
            description?: string;
            price?: ReturnType<typeof dependency_1.common.v1.Price.prototype.toObject>;
            cycle?: Cycle;
            status?: Status;
            visibility?: Visibility;
            products?: ReturnType<typeof PlanProduct.prototype.toObject>[];
            paymentMethods?: ReturnType<typeof PaymentMethod.prototype.toObject>;
            autoRenewal?: boolean;
            maxChargeAttempts?: number;
            overdueDays?: number;
            createdAt?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
            updatedAt?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
            trialDays?: number;
            mainAction?: boolean;
            planType?: Type;
            maxUsers?: number;
            removeAds?: boolean;
        }): Plan {
            const message = new Plan({});
            if (data.id != null) {
                message.id = data.id;
            }
            if (data.organizationId != null) {
                message.organizationId = data.organizationId;
            }
            if (data.name != null) {
                message.name = data.name;
            }
            if (data.description != null) {
                message.description = data.description;
            }
            if (data.price != null) {
                message.price = dependency_1.common.v1.Price.fromObject(data.price);
            }
            if (data.cycle != null) {
                message.cycle = data.cycle;
            }
            if (data.status != null) {
                message.status = data.status;
            }
            if (data.visibility != null) {
                message.visibility = data.visibility;
            }
            if (data.products != null) {
                message.products = data.products.map(item => PlanProduct.fromObject(item));
            }
            if (data.paymentMethods != null) {
                message.paymentMethods = PaymentMethod.fromObject(data.paymentMethods);
            }
            if (data.autoRenewal != null) {
                message.autoRenewal = data.autoRenewal;
            }
            if (data.maxChargeAttempts != null) {
                message.maxChargeAttempts = data.maxChargeAttempts;
            }
            if (data.overdueDays != null) {
                message.overdueDays = data.overdueDays;
            }
            if (data.createdAt != null) {
                message.createdAt = dependency_2.google.protobuf.Timestamp.fromObject(data.createdAt);
            }
            if (data.updatedAt != null) {
                message.updatedAt = dependency_2.google.protobuf.Timestamp.fromObject(data.updatedAt);
            }
            if (data.trialDays != null) {
                message.trialDays = data.trialDays;
            }
            if (data.mainAction != null) {
                message.mainAction = data.mainAction;
            }
            if (data.planType != null) {
                message.planType = data.planType;
            }
            if (data.maxUsers != null) {
                message.maxUsers = data.maxUsers;
            }
            if (data.removeAds != null) {
                message.removeAds = data.removeAds;
            }
            return message;
        }
        toObject() {
            const data: {
                id?: string;
                organizationId?: string;
                name?: string;
                description?: string;
                price?: ReturnType<typeof dependency_1.common.v1.Price.prototype.toObject>;
                cycle?: Cycle;
                status?: Status;
                visibility?: Visibility;
                products?: ReturnType<typeof PlanProduct.prototype.toObject>[];
                paymentMethods?: ReturnType<typeof PaymentMethod.prototype.toObject>;
                autoRenewal?: boolean;
                maxChargeAttempts?: number;
                overdueDays?: number;
                createdAt?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
                updatedAt?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
                trialDays?: number;
                mainAction?: boolean;
                planType?: Type;
                maxUsers?: number;
                removeAds?: boolean;
            } = {};
            if (this.id != null) {
                data.id = this.id;
            }
            if (this.organizationId != null) {
                data.organizationId = this.organizationId;
            }
            if (this.name != null) {
                data.name = this.name;
            }
            if (this.description != null) {
                data.description = this.description;
            }
            if (this.price != null) {
                data.price = this.price.toObject();
            }
            if (this.cycle != null) {
                data.cycle = this.cycle;
            }
            if (this.status != null) {
                data.status = this.status;
            }
            if (this.visibility != null) {
                data.visibility = this.visibility;
            }
            if (this.products != null) {
                data.products = this.products.map((item: PlanProduct) => item.toObject());
            }
            if (this.paymentMethods != null) {
                data.paymentMethods = this.paymentMethods.toObject();
            }
            if (this.autoRenewal != null) {
                data.autoRenewal = this.autoRenewal;
            }
            if (this.maxChargeAttempts != null) {
                data.maxChargeAttempts = this.maxChargeAttempts;
            }
            if (this.overdueDays != null) {
                data.overdueDays = this.overdueDays;
            }
            if (this.createdAt != null) {
                data.createdAt = this.createdAt.toObject();
            }
            if (this.updatedAt != null) {
                data.updatedAt = this.updatedAt.toObject();
            }
            if (this.trialDays != null) {
                data.trialDays = this.trialDays;
            }
            if (this.mainAction != null) {
                data.mainAction = this.mainAction;
            }
            if (this.planType != null) {
                data.planType = this.planType;
            }
            if (this.maxUsers != null) {
                data.maxUsers = this.maxUsers;
            }
            if (this.removeAds != null) {
                data.removeAds = this.removeAds;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.id.length)
                writer.writeString(1, this.id);
            if (this.organizationId.length)
                writer.writeString(2, this.organizationId);
            if (this.name.length)
                writer.writeString(3, this.name);
            if (this.description.length)
                writer.writeString(4, this.description);
            if (this.hasPrice)
                writer.writeMessage(5, this.price, () => this.price.serialize(writer));
            if (this.cycle != Cycle.CYCLE_UNSPECIFIED)
                writer.writeEnum(6, this.cycle);
            if (this.status != Status.STATUS_UNSPECIFIED)
                writer.writeEnum(7, this.status);
            if (this.visibility != Visibility.VISIBILITY_UNSPECIFIED)
                writer.writeEnum(8, this.visibility);
            if (this.products.length)
                writer.writeRepeatedMessage(9, this.products, (item: PlanProduct) => item.serialize(writer));
            if (this.hasPaymentMethods)
                writer.writeMessage(10, this.paymentMethods, () => this.paymentMethods.serialize(writer));
            if (this.autoRenewal != false)
                writer.writeBool(11, this.autoRenewal);
            if (this.maxChargeAttempts != 0)
                writer.writeInt32(12, this.maxChargeAttempts);
            if (this.overdueDays != 0)
                writer.writeInt32(13, this.overdueDays);
            if (this.hasCreatedAt)
                writer.writeMessage(14, this.createdAt, () => this.createdAt.serialize(writer));
            if (this.hasUpdatedAt)
                writer.writeMessage(15, this.updatedAt, () => this.updatedAt.serialize(writer));
            if (this.trialDays != 0)
                writer.writeInt32(16, this.trialDays);
            if (this.mainAction != false)
                writer.writeBool(17, this.mainAction);
            if (this.planType != Type.TYPE_UNSPECIFIED)
                writer.writeEnum(18, this.planType);
            if (this.maxUsers != 0)
                writer.writeInt32(19, this.maxUsers);
            if (this.removeAds != false)
                writer.writeBool(20, this.removeAds);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): Plan {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new Plan();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.id = reader.readString();
                        break;
                    case 2:
                        message.organizationId = reader.readString();
                        break;
                    case 3:
                        message.name = reader.readString();
                        break;
                    case 4:
                        message.description = reader.readString();
                        break;
                    case 5:
                        reader.readMessage(message.price, () => message.price = dependency_1.common.v1.Price.deserialize(reader));
                        break;
                    case 6:
                        message.cycle = reader.readEnum();
                        break;
                    case 7:
                        message.status = reader.readEnum();
                        break;
                    case 8:
                        message.visibility = reader.readEnum();
                        break;
                    case 9:
                        reader.readMessage(message.products, () => pb_1.Message.addToRepeatedWrapperField(message, 9, PlanProduct.deserialize(reader), PlanProduct));
                        break;
                    case 10:
                        reader.readMessage(message.paymentMethods, () => message.paymentMethods = PaymentMethod.deserialize(reader));
                        break;
                    case 11:
                        message.autoRenewal = reader.readBool();
                        break;
                    case 12:
                        message.maxChargeAttempts = reader.readInt32();
                        break;
                    case 13:
                        message.overdueDays = reader.readInt32();
                        break;
                    case 14:
                        reader.readMessage(message.createdAt, () => message.createdAt = dependency_2.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 15:
                        reader.readMessage(message.updatedAt, () => message.updatedAt = dependency_2.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 16:
                        message.trialDays = reader.readInt32();
                        break;
                    case 17:
                        message.mainAction = reader.readBool();
                        break;
                    case 18:
                        message.planType = reader.readEnum();
                        break;
                    case 19:
                        message.maxUsers = reader.readInt32();
                        break;
                    case 20:
                        message.removeAds = reader.readBool();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): Plan {
            return Plan.deserialize(bytes);
        }
    }
    export class Rule extends pb_1.Message {
        #one_of_decls: number[][] = [[2], [3]];
        constructor(data?: any[] | ({} & (({
            maxUsers?: number;
        }) | ({
            maxArticles?: number;
        })))) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("maxUsers" in data && data.maxUsers != undefined) {
                    this.maxUsers = data.maxUsers;
                }
                if ("maxArticles" in data && data.maxArticles != undefined) {
                    this.maxArticles = data.maxArticles;
                }
            }
        }
        get maxUsers() {
            return pb_1.Message.getFieldWithDefault(this, 2, 0) as number;
        }
        set maxUsers(value: number) {
            pb_1.Message.setOneofField(this, 2, this.#one_of_decls[0], value);
        }
        get hasMaxUsers() {
            return pb_1.Message.getField(this, 2) != null;
        }
        get maxArticles() {
            return pb_1.Message.getFieldWithDefault(this, 3, 0) as number;
        }
        set maxArticles(value: number) {
            pb_1.Message.setOneofField(this, 3, this.#one_of_decls[1], value);
        }
        get hasMaxArticles() {
            return pb_1.Message.getField(this, 3) != null;
        }
        get _max_users() {
            const cases: {
                [index: number]: "none" | "maxUsers";
            } = {
                0: "none",
                2: "maxUsers"
            };
            return cases[pb_1.Message.computeOneofCase(this, [2])];
        }
        get _max_articles() {
            const cases: {
                [index: number]: "none" | "maxArticles";
            } = {
                0: "none",
                3: "maxArticles"
            };
            return cases[pb_1.Message.computeOneofCase(this, [3])];
        }
        static fromObject(data: {
            maxUsers?: number;
            maxArticles?: number;
        }): Rule {
            const message = new Rule({});
            if (data.maxUsers != null) {
                message.maxUsers = data.maxUsers;
            }
            if (data.maxArticles != null) {
                message.maxArticles = data.maxArticles;
            }
            return message;
        }
        toObject() {
            const data: {
                maxUsers?: number;
                maxArticles?: number;
            } = {};
            if (this.maxUsers != null) {
                data.maxUsers = this.maxUsers;
            }
            if (this.maxArticles != null) {
                data.maxArticles = this.maxArticles;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasMaxUsers)
                writer.writeInt32(2, this.maxUsers);
            if (this.hasMaxArticles)
                writer.writeInt32(3, this.maxArticles);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): Rule {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new Rule();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 2:
                        message.maxUsers = reader.readInt32();
                        break;
                    case 3:
                        message.maxArticles = reader.readInt32();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): Rule {
            return Rule.deserialize(bytes);
        }
    }
    export class PaymentMethod extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            pixPaymentMethod?: PixPaymentMethod;
            creditPaymentMethod?: CreditPaymentMethod;
            debitPaymentMethod?: DebitPaymentMethod;
            bankSlipPaymentMethod?: BankSlipPaymentMethod;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("pixPaymentMethod" in data && data.pixPaymentMethod != undefined) {
                    this.pixPaymentMethod = data.pixPaymentMethod;
                }
                if ("creditPaymentMethod" in data && data.creditPaymentMethod != undefined) {
                    this.creditPaymentMethod = data.creditPaymentMethod;
                }
                if ("debitPaymentMethod" in data && data.debitPaymentMethod != undefined) {
                    this.debitPaymentMethod = data.debitPaymentMethod;
                }
                if ("bankSlipPaymentMethod" in data && data.bankSlipPaymentMethod != undefined) {
                    this.bankSlipPaymentMethod = data.bankSlipPaymentMethod;
                }
            }
        }
        get pixPaymentMethod() {
            return pb_1.Message.getWrapperField(this, PixPaymentMethod, 1) as PixPaymentMethod;
        }
        set pixPaymentMethod(value: PixPaymentMethod) {
            pb_1.Message.setWrapperField(this, 1, value);
        }
        get hasPixPaymentMethod() {
            return pb_1.Message.getField(this, 1) != null;
        }
        get creditPaymentMethod() {
            return pb_1.Message.getWrapperField(this, CreditPaymentMethod, 2) as CreditPaymentMethod;
        }
        set creditPaymentMethod(value: CreditPaymentMethod) {
            pb_1.Message.setWrapperField(this, 2, value);
        }
        get hasCreditPaymentMethod() {
            return pb_1.Message.getField(this, 2) != null;
        }
        get debitPaymentMethod() {
            return pb_1.Message.getWrapperField(this, DebitPaymentMethod, 3) as DebitPaymentMethod;
        }
        set debitPaymentMethod(value: DebitPaymentMethod) {
            pb_1.Message.setWrapperField(this, 3, value);
        }
        get hasDebitPaymentMethod() {
            return pb_1.Message.getField(this, 3) != null;
        }
        get bankSlipPaymentMethod() {
            return pb_1.Message.getWrapperField(this, BankSlipPaymentMethod, 4) as BankSlipPaymentMethod;
        }
        set bankSlipPaymentMethod(value: BankSlipPaymentMethod) {
            pb_1.Message.setWrapperField(this, 4, value);
        }
        get hasBankSlipPaymentMethod() {
            return pb_1.Message.getField(this, 4) != null;
        }
        static fromObject(data: {
            pixPaymentMethod?: ReturnType<typeof PixPaymentMethod.prototype.toObject>;
            creditPaymentMethod?: ReturnType<typeof CreditPaymentMethod.prototype.toObject>;
            debitPaymentMethod?: ReturnType<typeof DebitPaymentMethod.prototype.toObject>;
            bankSlipPaymentMethod?: ReturnType<typeof BankSlipPaymentMethod.prototype.toObject>;
        }): PaymentMethod {
            const message = new PaymentMethod({});
            if (data.pixPaymentMethod != null) {
                message.pixPaymentMethod = PixPaymentMethod.fromObject(data.pixPaymentMethod);
            }
            if (data.creditPaymentMethod != null) {
                message.creditPaymentMethod = CreditPaymentMethod.fromObject(data.creditPaymentMethod);
            }
            if (data.debitPaymentMethod != null) {
                message.debitPaymentMethod = DebitPaymentMethod.fromObject(data.debitPaymentMethod);
            }
            if (data.bankSlipPaymentMethod != null) {
                message.bankSlipPaymentMethod = BankSlipPaymentMethod.fromObject(data.bankSlipPaymentMethod);
            }
            return message;
        }
        toObject() {
            const data: {
                pixPaymentMethod?: ReturnType<typeof PixPaymentMethod.prototype.toObject>;
                creditPaymentMethod?: ReturnType<typeof CreditPaymentMethod.prototype.toObject>;
                debitPaymentMethod?: ReturnType<typeof DebitPaymentMethod.prototype.toObject>;
                bankSlipPaymentMethod?: ReturnType<typeof BankSlipPaymentMethod.prototype.toObject>;
            } = {};
            if (this.pixPaymentMethod != null) {
                data.pixPaymentMethod = this.pixPaymentMethod.toObject();
            }
            if (this.creditPaymentMethod != null) {
                data.creditPaymentMethod = this.creditPaymentMethod.toObject();
            }
            if (this.debitPaymentMethod != null) {
                data.debitPaymentMethod = this.debitPaymentMethod.toObject();
            }
            if (this.bankSlipPaymentMethod != null) {
                data.bankSlipPaymentMethod = this.bankSlipPaymentMethod.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasPixPaymentMethod)
                writer.writeMessage(1, this.pixPaymentMethod, () => this.pixPaymentMethod.serialize(writer));
            if (this.hasCreditPaymentMethod)
                writer.writeMessage(2, this.creditPaymentMethod, () => this.creditPaymentMethod.serialize(writer));
            if (this.hasDebitPaymentMethod)
                writer.writeMessage(3, this.debitPaymentMethod, () => this.debitPaymentMethod.serialize(writer));
            if (this.hasBankSlipPaymentMethod)
                writer.writeMessage(4, this.bankSlipPaymentMethod, () => this.bankSlipPaymentMethod.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): PaymentMethod {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new PaymentMethod();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.pixPaymentMethod, () => message.pixPaymentMethod = PixPaymentMethod.deserialize(reader));
                        break;
                    case 2:
                        reader.readMessage(message.creditPaymentMethod, () => message.creditPaymentMethod = CreditPaymentMethod.deserialize(reader));
                        break;
                    case 3:
                        reader.readMessage(message.debitPaymentMethod, () => message.debitPaymentMethod = DebitPaymentMethod.deserialize(reader));
                        break;
                    case 4:
                        reader.readMessage(message.bankSlipPaymentMethod, () => message.bankSlipPaymentMethod = BankSlipPaymentMethod.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): PaymentMethod {
            return PaymentMethod.deserialize(bytes);
        }
    }
    export class PixPaymentMethod extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            enable?: boolean;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("enable" in data && data.enable != undefined) {
                    this.enable = data.enable;
                }
            }
        }
        get enable() {
            return pb_1.Message.getFieldWithDefault(this, 1, false) as boolean;
        }
        set enable(value: boolean) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            enable?: boolean;
        }): PixPaymentMethod {
            const message = new PixPaymentMethod({});
            if (data.enable != null) {
                message.enable = data.enable;
            }
            return message;
        }
        toObject() {
            const data: {
                enable?: boolean;
            } = {};
            if (this.enable != null) {
                data.enable = this.enable;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.enable != false)
                writer.writeBool(1, this.enable);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): PixPaymentMethod {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new PixPaymentMethod();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.enable = reader.readBool();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): PixPaymentMethod {
            return PixPaymentMethod.deserialize(bytes);
        }
    }
    export class CreditPaymentMethod extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            enable?: boolean;
            configCreditPaymentMethod?: ConfigCreditPaymentMethod[];
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [2], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("enable" in data && data.enable != undefined) {
                    this.enable = data.enable;
                }
                if ("configCreditPaymentMethod" in data && data.configCreditPaymentMethod != undefined) {
                    this.configCreditPaymentMethod = data.configCreditPaymentMethod;
                }
            }
        }
        get enable() {
            return pb_1.Message.getFieldWithDefault(this, 1, false) as boolean;
        }
        set enable(value: boolean) {
            pb_1.Message.setField(this, 1, value);
        }
        get configCreditPaymentMethod() {
            return pb_1.Message.getRepeatedWrapperField(this, ConfigCreditPaymentMethod, 2) as ConfigCreditPaymentMethod[];
        }
        set configCreditPaymentMethod(value: ConfigCreditPaymentMethod[]) {
            pb_1.Message.setRepeatedWrapperField(this, 2, value);
        }
        static fromObject(data: {
            enable?: boolean;
            configCreditPaymentMethod?: ReturnType<typeof ConfigCreditPaymentMethod.prototype.toObject>[];
        }): CreditPaymentMethod {
            const message = new CreditPaymentMethod({});
            if (data.enable != null) {
                message.enable = data.enable;
            }
            if (data.configCreditPaymentMethod != null) {
                message.configCreditPaymentMethod = data.configCreditPaymentMethod.map(item => ConfigCreditPaymentMethod.fromObject(item));
            }
            return message;
        }
        toObject() {
            const data: {
                enable?: boolean;
                configCreditPaymentMethod?: ReturnType<typeof ConfigCreditPaymentMethod.prototype.toObject>[];
            } = {};
            if (this.enable != null) {
                data.enable = this.enable;
            }
            if (this.configCreditPaymentMethod != null) {
                data.configCreditPaymentMethod = this.configCreditPaymentMethod.map((item: ConfigCreditPaymentMethod) => item.toObject());
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.enable != false)
                writer.writeBool(1, this.enable);
            if (this.configCreditPaymentMethod.length)
                writer.writeRepeatedMessage(2, this.configCreditPaymentMethod, (item: ConfigCreditPaymentMethod) => item.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): CreditPaymentMethod {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CreditPaymentMethod();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.enable = reader.readBool();
                        break;
                    case 2:
                        reader.readMessage(message.configCreditPaymentMethod, () => pb_1.Message.addToRepeatedWrapperField(message, 2, ConfigCreditPaymentMethod.deserialize(reader), ConfigCreditPaymentMethod));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): CreditPaymentMethod {
            return CreditPaymentMethod.deserialize(bytes);
        }
    }
    export class ConfigCreditPaymentMethod extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            fee?: number;
            installment?: number;
            enable?: boolean;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("fee" in data && data.fee != undefined) {
                    this.fee = data.fee;
                }
                if ("installment" in data && data.installment != undefined) {
                    this.installment = data.installment;
                }
                if ("enable" in data && data.enable != undefined) {
                    this.enable = data.enable;
                }
            }
        }
        get fee() {
            return pb_1.Message.getFieldWithDefault(this, 1, 0) as number;
        }
        set fee(value: number) {
            pb_1.Message.setField(this, 1, value);
        }
        get installment() {
            return pb_1.Message.getFieldWithDefault(this, 2, 0) as number;
        }
        set installment(value: number) {
            pb_1.Message.setField(this, 2, value);
        }
        get enable() {
            return pb_1.Message.getFieldWithDefault(this, 3, false) as boolean;
        }
        set enable(value: boolean) {
            pb_1.Message.setField(this, 3, value);
        }
        static fromObject(data: {
            fee?: number;
            installment?: number;
            enable?: boolean;
        }): ConfigCreditPaymentMethod {
            const message = new ConfigCreditPaymentMethod({});
            if (data.fee != null) {
                message.fee = data.fee;
            }
            if (data.installment != null) {
                message.installment = data.installment;
            }
            if (data.enable != null) {
                message.enable = data.enable;
            }
            return message;
        }
        toObject() {
            const data: {
                fee?: number;
                installment?: number;
                enable?: boolean;
            } = {};
            if (this.fee != null) {
                data.fee = this.fee;
            }
            if (this.installment != null) {
                data.installment = this.installment;
            }
            if (this.enable != null) {
                data.enable = this.enable;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.fee != 0)
                writer.writeInt32(1, this.fee);
            if (this.installment != 0)
                writer.writeInt32(2, this.installment);
            if (this.enable != false)
                writer.writeBool(3, this.enable);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ConfigCreditPaymentMethod {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ConfigCreditPaymentMethod();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.fee = reader.readInt32();
                        break;
                    case 2:
                        message.installment = reader.readInt32();
                        break;
                    case 3:
                        message.enable = reader.readBool();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): ConfigCreditPaymentMethod {
            return ConfigCreditPaymentMethod.deserialize(bytes);
        }
    }
    export class DebitPaymentMethod extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            enable?: boolean;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("enable" in data && data.enable != undefined) {
                    this.enable = data.enable;
                }
            }
        }
        get enable() {
            return pb_1.Message.getFieldWithDefault(this, 1, false) as boolean;
        }
        set enable(value: boolean) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            enable?: boolean;
        }): DebitPaymentMethod {
            const message = new DebitPaymentMethod({});
            if (data.enable != null) {
                message.enable = data.enable;
            }
            return message;
        }
        toObject() {
            const data: {
                enable?: boolean;
            } = {};
            if (this.enable != null) {
                data.enable = this.enable;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.enable != false)
                writer.writeBool(1, this.enable);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): DebitPaymentMethod {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new DebitPaymentMethod();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.enable = reader.readBool();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): DebitPaymentMethod {
            return DebitPaymentMethod.deserialize(bytes);
        }
    }
    export class BankSlipPaymentMethod extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            enable?: boolean;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("enable" in data && data.enable != undefined) {
                    this.enable = data.enable;
                }
            }
        }
        get enable() {
            return pb_1.Message.getFieldWithDefault(this, 1, false) as boolean;
        }
        set enable(value: boolean) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            enable?: boolean;
        }): BankSlipPaymentMethod {
            const message = new BankSlipPaymentMethod({});
            if (data.enable != null) {
                message.enable = data.enable;
            }
            return message;
        }
        toObject() {
            const data: {
                enable?: boolean;
            } = {};
            if (this.enable != null) {
                data.enable = this.enable;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.enable != false)
                writer.writeBool(1, this.enable);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): BankSlipPaymentMethod {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new BankSlipPaymentMethod();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.enable = reader.readBool();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): BankSlipPaymentMethod {
            return BankSlipPaymentMethod.deserialize(bytes);
        }
    }
    export class PlanProdRequest extends pb_1.Message {
        #one_of_decls: number[][] = [[2]];
        constructor(data?: any[] | ({
            productId?: string;
            active?: boolean;
            resources?: Resource[];
        } & (({
            rules?: Rule;
        })))) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [4], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("productId" in data && data.productId != undefined) {
                    this.productId = data.productId;
                }
                if ("rules" in data && data.rules != undefined) {
                    this.rules = data.rules;
                }
                if ("active" in data && data.active != undefined) {
                    this.active = data.active;
                }
                if ("resources" in data && data.resources != undefined) {
                    this.resources = data.resources;
                }
            }
        }
        get productId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set productId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get rules() {
            return pb_1.Message.getWrapperField(this, Rule, 2) as Rule;
        }
        set rules(value: Rule) {
            pb_1.Message.setOneofWrapperField(this, 2, this.#one_of_decls[0], value);
        }
        get hasRules() {
            return pb_1.Message.getField(this, 2) != null;
        }
        get active() {
            return pb_1.Message.getFieldWithDefault(this, 3, false) as boolean;
        }
        set active(value: boolean) {
            pb_1.Message.setField(this, 3, value);
        }
        get resources() {
            return pb_1.Message.getRepeatedWrapperField(this, Resource, 4) as Resource[];
        }
        set resources(value: Resource[]) {
            pb_1.Message.setRepeatedWrapperField(this, 4, value);
        }
        get _rules() {
            const cases: {
                [index: number]: "none" | "rules";
            } = {
                0: "none",
                2: "rules"
            };
            return cases[pb_1.Message.computeOneofCase(this, [2])];
        }
        static fromObject(data: {
            productId?: string;
            rules?: ReturnType<typeof Rule.prototype.toObject>;
            active?: boolean;
            resources?: ReturnType<typeof Resource.prototype.toObject>[];
        }): PlanProdRequest {
            const message = new PlanProdRequest({});
            if (data.productId != null) {
                message.productId = data.productId;
            }
            if (data.rules != null) {
                message.rules = Rule.fromObject(data.rules);
            }
            if (data.active != null) {
                message.active = data.active;
            }
            if (data.resources != null) {
                message.resources = data.resources.map(item => Resource.fromObject(item));
            }
            return message;
        }
        toObject() {
            const data: {
                productId?: string;
                rules?: ReturnType<typeof Rule.prototype.toObject>;
                active?: boolean;
                resources?: ReturnType<typeof Resource.prototype.toObject>[];
            } = {};
            if (this.productId != null) {
                data.productId = this.productId;
            }
            if (this.rules != null) {
                data.rules = this.rules.toObject();
            }
            if (this.active != null) {
                data.active = this.active;
            }
            if (this.resources != null) {
                data.resources = this.resources.map((item: Resource) => item.toObject());
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.productId.length)
                writer.writeString(1, this.productId);
            if (this.hasRules)
                writer.writeMessage(2, this.rules, () => this.rules.serialize(writer));
            if (this.active != false)
                writer.writeBool(3, this.active);
            if (this.resources.length)
                writer.writeRepeatedMessage(4, this.resources, (item: Resource) => item.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): PlanProdRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new PlanProdRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.productId = reader.readString();
                        break;
                    case 2:
                        reader.readMessage(message.rules, () => message.rules = Rule.deserialize(reader));
                        break;
                    case 3:
                        message.active = reader.readBool();
                        break;
                    case 4:
                        reader.readMessage(message.resources, () => pb_1.Message.addToRepeatedWrapperField(message, 4, Resource.deserialize(reader), Resource));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): PlanProdRequest {
            return PlanProdRequest.deserialize(bytes);
        }
    }
    export class CreatePlanRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            name?: string;
            description?: string;
            price?: dependency_1.common.v1.Price;
            cycle?: Cycle;
            visibility?: Visibility;
            products?: PlanProdRequest[];
            paymentMethods?: PaymentMethod;
            autoRenewal?: boolean;
            maxChargeAttempts?: number;
            overdueDays?: number;
            trialDays?: number;
            status?: Status;
            mainAction?: boolean;
            planType?: Type;
            removedAds?: boolean;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [6], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("name" in data && data.name != undefined) {
                    this.name = data.name;
                }
                if ("description" in data && data.description != undefined) {
                    this.description = data.description;
                }
                if ("price" in data && data.price != undefined) {
                    this.price = data.price;
                }
                if ("cycle" in data && data.cycle != undefined) {
                    this.cycle = data.cycle;
                }
                if ("visibility" in data && data.visibility != undefined) {
                    this.visibility = data.visibility;
                }
                if ("products" in data && data.products != undefined) {
                    this.products = data.products;
                }
                if ("paymentMethods" in data && data.paymentMethods != undefined) {
                    this.paymentMethods = data.paymentMethods;
                }
                if ("autoRenewal" in data && data.autoRenewal != undefined) {
                    this.autoRenewal = data.autoRenewal;
                }
                if ("maxChargeAttempts" in data && data.maxChargeAttempts != undefined) {
                    this.maxChargeAttempts = data.maxChargeAttempts;
                }
                if ("overdueDays" in data && data.overdueDays != undefined) {
                    this.overdueDays = data.overdueDays;
                }
                if ("trialDays" in data && data.trialDays != undefined) {
                    this.trialDays = data.trialDays;
                }
                if ("status" in data && data.status != undefined) {
                    this.status = data.status;
                }
                if ("mainAction" in data && data.mainAction != undefined) {
                    this.mainAction = data.mainAction;
                }
                if ("planType" in data && data.planType != undefined) {
                    this.planType = data.planType;
                }
                if ("removedAds" in data && data.removedAds != undefined) {
                    this.removedAds = data.removedAds;
                }
            }
        }
        get name() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set name(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get description() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set description(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get price() {
            return pb_1.Message.getWrapperField(this, dependency_1.common.v1.Price, 3) as dependency_1.common.v1.Price;
        }
        set price(value: dependency_1.common.v1.Price) {
            pb_1.Message.setWrapperField(this, 3, value);
        }
        get hasPrice() {
            return pb_1.Message.getField(this, 3) != null;
        }
        get cycle() {
            return pb_1.Message.getFieldWithDefault(this, 4, Cycle.CYCLE_UNSPECIFIED) as Cycle;
        }
        set cycle(value: Cycle) {
            pb_1.Message.setField(this, 4, value);
        }
        get visibility() {
            return pb_1.Message.getFieldWithDefault(this, 5, Visibility.VISIBILITY_UNSPECIFIED) as Visibility;
        }
        set visibility(value: Visibility) {
            pb_1.Message.setField(this, 5, value);
        }
        get products() {
            return pb_1.Message.getRepeatedWrapperField(this, PlanProdRequest, 6) as PlanProdRequest[];
        }
        set products(value: PlanProdRequest[]) {
            pb_1.Message.setRepeatedWrapperField(this, 6, value);
        }
        get paymentMethods() {
            return pb_1.Message.getWrapperField(this, PaymentMethod, 7) as PaymentMethod;
        }
        set paymentMethods(value: PaymentMethod) {
            pb_1.Message.setWrapperField(this, 7, value);
        }
        get hasPaymentMethods() {
            return pb_1.Message.getField(this, 7) != null;
        }
        get autoRenewal() {
            return pb_1.Message.getFieldWithDefault(this, 8, false) as boolean;
        }
        set autoRenewal(value: boolean) {
            pb_1.Message.setField(this, 8, value);
        }
        get maxChargeAttempts() {
            return pb_1.Message.getFieldWithDefault(this, 9, 0) as number;
        }
        set maxChargeAttempts(value: number) {
            pb_1.Message.setField(this, 9, value);
        }
        get overdueDays() {
            return pb_1.Message.getFieldWithDefault(this, 10, 0) as number;
        }
        set overdueDays(value: number) {
            pb_1.Message.setField(this, 10, value);
        }
        get trialDays() {
            return pb_1.Message.getFieldWithDefault(this, 12, 0) as number;
        }
        set trialDays(value: number) {
            pb_1.Message.setField(this, 12, value);
        }
        get status() {
            return pb_1.Message.getFieldWithDefault(this, 13, Status.STATUS_UNSPECIFIED) as Status;
        }
        set status(value: Status) {
            pb_1.Message.setField(this, 13, value);
        }
        get mainAction() {
            return pb_1.Message.getFieldWithDefault(this, 14, false) as boolean;
        }
        set mainAction(value: boolean) {
            pb_1.Message.setField(this, 14, value);
        }
        get planType() {
            return pb_1.Message.getFieldWithDefault(this, 15, Type.TYPE_UNSPECIFIED) as Type;
        }
        set planType(value: Type) {
            pb_1.Message.setField(this, 15, value);
        }
        get removedAds() {
            return pb_1.Message.getFieldWithDefault(this, 16, false) as boolean;
        }
        set removedAds(value: boolean) {
            pb_1.Message.setField(this, 16, value);
        }
        static fromObject(data: {
            name?: string;
            description?: string;
            price?: ReturnType<typeof dependency_1.common.v1.Price.prototype.toObject>;
            cycle?: Cycle;
            visibility?: Visibility;
            products?: ReturnType<typeof PlanProdRequest.prototype.toObject>[];
            paymentMethods?: ReturnType<typeof PaymentMethod.prototype.toObject>;
            autoRenewal?: boolean;
            maxChargeAttempts?: number;
            overdueDays?: number;
            trialDays?: number;
            status?: Status;
            mainAction?: boolean;
            planType?: Type;
            removedAds?: boolean;
        }): CreatePlanRequest {
            const message = new CreatePlanRequest({});
            if (data.name != null) {
                message.name = data.name;
            }
            if (data.description != null) {
                message.description = data.description;
            }
            if (data.price != null) {
                message.price = dependency_1.common.v1.Price.fromObject(data.price);
            }
            if (data.cycle != null) {
                message.cycle = data.cycle;
            }
            if (data.visibility != null) {
                message.visibility = data.visibility;
            }
            if (data.products != null) {
                message.products = data.products.map(item => PlanProdRequest.fromObject(item));
            }
            if (data.paymentMethods != null) {
                message.paymentMethods = PaymentMethod.fromObject(data.paymentMethods);
            }
            if (data.autoRenewal != null) {
                message.autoRenewal = data.autoRenewal;
            }
            if (data.maxChargeAttempts != null) {
                message.maxChargeAttempts = data.maxChargeAttempts;
            }
            if (data.overdueDays != null) {
                message.overdueDays = data.overdueDays;
            }
            if (data.trialDays != null) {
                message.trialDays = data.trialDays;
            }
            if (data.status != null) {
                message.status = data.status;
            }
            if (data.mainAction != null) {
                message.mainAction = data.mainAction;
            }
            if (data.planType != null) {
                message.planType = data.planType;
            }
            if (data.removedAds != null) {
                message.removedAds = data.removedAds;
            }
            return message;
        }
        toObject() {
            const data: {
                name?: string;
                description?: string;
                price?: ReturnType<typeof dependency_1.common.v1.Price.prototype.toObject>;
                cycle?: Cycle;
                visibility?: Visibility;
                products?: ReturnType<typeof PlanProdRequest.prototype.toObject>[];
                paymentMethods?: ReturnType<typeof PaymentMethod.prototype.toObject>;
                autoRenewal?: boolean;
                maxChargeAttempts?: number;
                overdueDays?: number;
                trialDays?: number;
                status?: Status;
                mainAction?: boolean;
                planType?: Type;
                removedAds?: boolean;
            } = {};
            if (this.name != null) {
                data.name = this.name;
            }
            if (this.description != null) {
                data.description = this.description;
            }
            if (this.price != null) {
                data.price = this.price.toObject();
            }
            if (this.cycle != null) {
                data.cycle = this.cycle;
            }
            if (this.visibility != null) {
                data.visibility = this.visibility;
            }
            if (this.products != null) {
                data.products = this.products.map((item: PlanProdRequest) => item.toObject());
            }
            if (this.paymentMethods != null) {
                data.paymentMethods = this.paymentMethods.toObject();
            }
            if (this.autoRenewal != null) {
                data.autoRenewal = this.autoRenewal;
            }
            if (this.maxChargeAttempts != null) {
                data.maxChargeAttempts = this.maxChargeAttempts;
            }
            if (this.overdueDays != null) {
                data.overdueDays = this.overdueDays;
            }
            if (this.trialDays != null) {
                data.trialDays = this.trialDays;
            }
            if (this.status != null) {
                data.status = this.status;
            }
            if (this.mainAction != null) {
                data.mainAction = this.mainAction;
            }
            if (this.planType != null) {
                data.planType = this.planType;
            }
            if (this.removedAds != null) {
                data.removedAds = this.removedAds;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.name.length)
                writer.writeString(1, this.name);
            if (this.description.length)
                writer.writeString(2, this.description);
            if (this.hasPrice)
                writer.writeMessage(3, this.price, () => this.price.serialize(writer));
            if (this.cycle != Cycle.CYCLE_UNSPECIFIED)
                writer.writeEnum(4, this.cycle);
            if (this.visibility != Visibility.VISIBILITY_UNSPECIFIED)
                writer.writeEnum(5, this.visibility);
            if (this.products.length)
                writer.writeRepeatedMessage(6, this.products, (item: PlanProdRequest) => item.serialize(writer));
            if (this.hasPaymentMethods)
                writer.writeMessage(7, this.paymentMethods, () => this.paymentMethods.serialize(writer));
            if (this.autoRenewal != false)
                writer.writeBool(8, this.autoRenewal);
            if (this.maxChargeAttempts != 0)
                writer.writeInt32(9, this.maxChargeAttempts);
            if (this.overdueDays != 0)
                writer.writeInt32(10, this.overdueDays);
            if (this.trialDays != 0)
                writer.writeInt32(12, this.trialDays);
            if (this.status != Status.STATUS_UNSPECIFIED)
                writer.writeEnum(13, this.status);
            if (this.mainAction != false)
                writer.writeBool(14, this.mainAction);
            if (this.planType != Type.TYPE_UNSPECIFIED)
                writer.writeEnum(15, this.planType);
            if (this.removedAds != false)
                writer.writeBool(16, this.removedAds);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): CreatePlanRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CreatePlanRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.name = reader.readString();
                        break;
                    case 2:
                        message.description = reader.readString();
                        break;
                    case 3:
                        reader.readMessage(message.price, () => message.price = dependency_1.common.v1.Price.deserialize(reader));
                        break;
                    case 4:
                        message.cycle = reader.readEnum();
                        break;
                    case 5:
                        message.visibility = reader.readEnum();
                        break;
                    case 6:
                        reader.readMessage(message.products, () => pb_1.Message.addToRepeatedWrapperField(message, 6, PlanProdRequest.deserialize(reader), PlanProdRequest));
                        break;
                    case 7:
                        reader.readMessage(message.paymentMethods, () => message.paymentMethods = PaymentMethod.deserialize(reader));
                        break;
                    case 8:
                        message.autoRenewal = reader.readBool();
                        break;
                    case 9:
                        message.maxChargeAttempts = reader.readInt32();
                        break;
                    case 10:
                        message.overdueDays = reader.readInt32();
                        break;
                    case 12:
                        message.trialDays = reader.readInt32();
                        break;
                    case 13:
                        message.status = reader.readEnum();
                        break;
                    case 14:
                        message.mainAction = reader.readBool();
                        break;
                    case 15:
                        message.planType = reader.readEnum();
                        break;
                    case 16:
                        message.removedAds = reader.readBool();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): CreatePlanRequest {
            return CreatePlanRequest.deserialize(bytes);
        }
    }
    export class GetPlanRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            id?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("id" in data && data.id != undefined) {
                    this.id = data.id;
                }
            }
        }
        get id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            id?: string;
        }): GetPlanRequest {
            const message = new GetPlanRequest({});
            if (data.id != null) {
                message.id = data.id;
            }
            return message;
        }
        toObject() {
            const data: {
                id?: string;
            } = {};
            if (this.id != null) {
                data.id = this.id;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.id.length)
                writer.writeString(1, this.id);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetPlanRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetPlanRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.id = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetPlanRequest {
            return GetPlanRequest.deserialize(bytes);
        }
    }
    export class ListPlansRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            page?: number;
            pageSize?: number;
            sortBy?: string;
            sortOrder?: string;
            name?: string[];
            status?: Status[];
            searchTerms?: string;
            visibility?: Visibility[];
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [5, 6, 8], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("page" in data && data.page != undefined) {
                    this.page = data.page;
                }
                if ("pageSize" in data && data.pageSize != undefined) {
                    this.pageSize = data.pageSize;
                }
                if ("sortBy" in data && data.sortBy != undefined) {
                    this.sortBy = data.sortBy;
                }
                if ("sortOrder" in data && data.sortOrder != undefined) {
                    this.sortOrder = data.sortOrder;
                }
                if ("name" in data && data.name != undefined) {
                    this.name = data.name;
                }
                if ("status" in data && data.status != undefined) {
                    this.status = data.status;
                }
                if ("searchTerms" in data && data.searchTerms != undefined) {
                    this.searchTerms = data.searchTerms;
                }
                if ("visibility" in data && data.visibility != undefined) {
                    this.visibility = data.visibility;
                }
            }
        }
        get page() {
            return pb_1.Message.getFieldWithDefault(this, 1, 0) as number;
        }
        set page(value: number) {
            pb_1.Message.setField(this, 1, value);
        }
        get pageSize() {
            return pb_1.Message.getFieldWithDefault(this, 2, 0) as number;
        }
        set pageSize(value: number) {
            pb_1.Message.setField(this, 2, value);
        }
        get sortBy() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set sortBy(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get sortOrder() {
            return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
        }
        set sortOrder(value: string) {
            pb_1.Message.setField(this, 4, value);
        }
        get name() {
            return pb_1.Message.getFieldWithDefault(this, 5, []) as string[];
        }
        set name(value: string[]) {
            pb_1.Message.setField(this, 5, value);
        }
        get status() {
            return pb_1.Message.getFieldWithDefault(this, 6, []) as Status[];
        }
        set status(value: Status[]) {
            pb_1.Message.setField(this, 6, value);
        }
        get searchTerms() {
            return pb_1.Message.getFieldWithDefault(this, 7, "") as string;
        }
        set searchTerms(value: string) {
            pb_1.Message.setField(this, 7, value);
        }
        get visibility() {
            return pb_1.Message.getFieldWithDefault(this, 8, []) as Visibility[];
        }
        set visibility(value: Visibility[]) {
            pb_1.Message.setField(this, 8, value);
        }
        static fromObject(data: {
            page?: number;
            pageSize?: number;
            sortBy?: string;
            sortOrder?: string;
            name?: string[];
            status?: Status[];
            searchTerms?: string;
            visibility?: Visibility[];
        }): ListPlansRequest {
            const message = new ListPlansRequest({});
            if (data.page != null) {
                message.page = data.page;
            }
            if (data.pageSize != null) {
                message.pageSize = data.pageSize;
            }
            if (data.sortBy != null) {
                message.sortBy = data.sortBy;
            }
            if (data.sortOrder != null) {
                message.sortOrder = data.sortOrder;
            }
            if (data.name != null) {
                message.name = data.name;
            }
            if (data.status != null) {
                message.status = data.status;
            }
            if (data.searchTerms != null) {
                message.searchTerms = data.searchTerms;
            }
            if (data.visibility != null) {
                message.visibility = data.visibility;
            }
            return message;
        }
        toObject() {
            const data: {
                page?: number;
                pageSize?: number;
                sortBy?: string;
                sortOrder?: string;
                name?: string[];
                status?: Status[];
                searchTerms?: string;
                visibility?: Visibility[];
            } = {};
            if (this.page != null) {
                data.page = this.page;
            }
            if (this.pageSize != null) {
                data.pageSize = this.pageSize;
            }
            if (this.sortBy != null) {
                data.sortBy = this.sortBy;
            }
            if (this.sortOrder != null) {
                data.sortOrder = this.sortOrder;
            }
            if (this.name != null) {
                data.name = this.name;
            }
            if (this.status != null) {
                data.status = this.status;
            }
            if (this.searchTerms != null) {
                data.searchTerms = this.searchTerms;
            }
            if (this.visibility != null) {
                data.visibility = this.visibility;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.page != 0)
                writer.writeInt32(1, this.page);
            if (this.pageSize != 0)
                writer.writeInt32(2, this.pageSize);
            if (this.sortBy.length)
                writer.writeString(3, this.sortBy);
            if (this.sortOrder.length)
                writer.writeString(4, this.sortOrder);
            if (this.name.length)
                writer.writeRepeatedString(5, this.name);
            if (this.status.length)
                writer.writePackedEnum(6, this.status);
            if (this.searchTerms.length)
                writer.writeString(7, this.searchTerms);
            if (this.visibility.length)
                writer.writePackedEnum(8, this.visibility);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ListPlansRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ListPlansRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.page = reader.readInt32();
                        break;
                    case 2:
                        message.pageSize = reader.readInt32();
                        break;
                    case 3:
                        message.sortBy = reader.readString();
                        break;
                    case 4:
                        message.sortOrder = reader.readString();
                        break;
                    case 5:
                        pb_1.Message.addToRepeatedField(message, 5, reader.readString());
                        break;
                    case 6:
                        message.status = reader.readPackedEnum();
                        break;
                    case 7:
                        message.searchTerms = reader.readString();
                        break;
                    case 8:
                        message.visibility = reader.readPackedEnum();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): ListPlansRequest {
            return ListPlansRequest.deserialize(bytes);
        }
    }
    export class DeletePlanRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            id?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("id" in data && data.id != undefined) {
                    this.id = data.id;
                }
            }
        }
        get id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            id?: string;
        }): DeletePlanRequest {
            const message = new DeletePlanRequest({});
            if (data.id != null) {
                message.id = data.id;
            }
            return message;
        }
        toObject() {
            const data: {
                id?: string;
            } = {};
            if (this.id != null) {
                data.id = this.id;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.id.length)
                writer.writeString(1, this.id);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): DeletePlanRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new DeletePlanRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.id = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): DeletePlanRequest {
            return DeletePlanRequest.deserialize(bytes);
        }
    }
    export class CreatePlanResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            plan?: Plan;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("plan" in data && data.plan != undefined) {
                    this.plan = data.plan;
                }
            }
        }
        get plan() {
            return pb_1.Message.getWrapperField(this, Plan, 1) as Plan;
        }
        set plan(value: Plan) {
            pb_1.Message.setWrapperField(this, 1, value);
        }
        get hasPlan() {
            return pb_1.Message.getField(this, 1) != null;
        }
        static fromObject(data: {
            plan?: ReturnType<typeof Plan.prototype.toObject>;
        }): CreatePlanResponse {
            const message = new CreatePlanResponse({});
            if (data.plan != null) {
                message.plan = Plan.fromObject(data.plan);
            }
            return message;
        }
        toObject() {
            const data: {
                plan?: ReturnType<typeof Plan.prototype.toObject>;
            } = {};
            if (this.plan != null) {
                data.plan = this.plan.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasPlan)
                writer.writeMessage(1, this.plan, () => this.plan.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): CreatePlanResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CreatePlanResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.plan, () => message.plan = Plan.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): CreatePlanResponse {
            return CreatePlanResponse.deserialize(bytes);
        }
    }
    export class GetPlanResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            plan?: Plan;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("plan" in data && data.plan != undefined) {
                    this.plan = data.plan;
                }
            }
        }
        get plan() {
            return pb_1.Message.getWrapperField(this, Plan, 1) as Plan;
        }
        set plan(value: Plan) {
            pb_1.Message.setWrapperField(this, 1, value);
        }
        get hasPlan() {
            return pb_1.Message.getField(this, 1) != null;
        }
        static fromObject(data: {
            plan?: ReturnType<typeof Plan.prototype.toObject>;
        }): GetPlanResponse {
            const message = new GetPlanResponse({});
            if (data.plan != null) {
                message.plan = Plan.fromObject(data.plan);
            }
            return message;
        }
        toObject() {
            const data: {
                plan?: ReturnType<typeof Plan.prototype.toObject>;
            } = {};
            if (this.plan != null) {
                data.plan = this.plan.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasPlan)
                writer.writeMessage(1, this.plan, () => this.plan.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetPlanResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetPlanResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.plan, () => message.plan = Plan.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetPlanResponse {
            return GetPlanResponse.deserialize(bytes);
        }
    }
    export class ListPlansResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            plans?: Plan[];
            totalCount?: number;
            totalPages?: number;
            hasNext?: boolean;
            hasPrev?: boolean;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [1], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("plans" in data && data.plans != undefined) {
                    this.plans = data.plans;
                }
                if ("totalCount" in data && data.totalCount != undefined) {
                    this.totalCount = data.totalCount;
                }
                if ("totalPages" in data && data.totalPages != undefined) {
                    this.totalPages = data.totalPages;
                }
                if ("hasNext" in data && data.hasNext != undefined) {
                    this.hasNext = data.hasNext;
                }
                if ("hasPrev" in data && data.hasPrev != undefined) {
                    this.hasPrev = data.hasPrev;
                }
            }
        }
        get plans() {
            return pb_1.Message.getRepeatedWrapperField(this, Plan, 1) as Plan[];
        }
        set plans(value: Plan[]) {
            pb_1.Message.setRepeatedWrapperField(this, 1, value);
        }
        get totalCount() {
            return pb_1.Message.getFieldWithDefault(this, 2, 0) as number;
        }
        set totalCount(value: number) {
            pb_1.Message.setField(this, 2, value);
        }
        get totalPages() {
            return pb_1.Message.getFieldWithDefault(this, 3, 0) as number;
        }
        set totalPages(value: number) {
            pb_1.Message.setField(this, 3, value);
        }
        get hasNext() {
            return pb_1.Message.getFieldWithDefault(this, 4, false) as boolean;
        }
        set hasNext(value: boolean) {
            pb_1.Message.setField(this, 4, value);
        }
        get hasPrev() {
            return pb_1.Message.getFieldWithDefault(this, 5, false) as boolean;
        }
        set hasPrev(value: boolean) {
            pb_1.Message.setField(this, 5, value);
        }
        static fromObject(data: {
            plans?: ReturnType<typeof Plan.prototype.toObject>[];
            totalCount?: number;
            totalPages?: number;
            hasNext?: boolean;
            hasPrev?: boolean;
        }): ListPlansResponse {
            const message = new ListPlansResponse({});
            if (data.plans != null) {
                message.plans = data.plans.map(item => Plan.fromObject(item));
            }
            if (data.totalCount != null) {
                message.totalCount = data.totalCount;
            }
            if (data.totalPages != null) {
                message.totalPages = data.totalPages;
            }
            if (data.hasNext != null) {
                message.hasNext = data.hasNext;
            }
            if (data.hasPrev != null) {
                message.hasPrev = data.hasPrev;
            }
            return message;
        }
        toObject() {
            const data: {
                plans?: ReturnType<typeof Plan.prototype.toObject>[];
                totalCount?: number;
                totalPages?: number;
                hasNext?: boolean;
                hasPrev?: boolean;
            } = {};
            if (this.plans != null) {
                data.plans = this.plans.map((item: Plan) => item.toObject());
            }
            if (this.totalCount != null) {
                data.totalCount = this.totalCount;
            }
            if (this.totalPages != null) {
                data.totalPages = this.totalPages;
            }
            if (this.hasNext != null) {
                data.hasNext = this.hasNext;
            }
            if (this.hasPrev != null) {
                data.hasPrev = this.hasPrev;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.plans.length)
                writer.writeRepeatedMessage(1, this.plans, (item: Plan) => item.serialize(writer));
            if (this.totalCount != 0)
                writer.writeInt32(2, this.totalCount);
            if (this.totalPages != 0)
                writer.writeInt32(3, this.totalPages);
            if (this.hasNext != false)
                writer.writeBool(4, this.hasNext);
            if (this.hasPrev != false)
                writer.writeBool(5, this.hasPrev);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ListPlansResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ListPlansResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.plans, () => pb_1.Message.addToRepeatedWrapperField(message, 1, Plan.deserialize(reader), Plan));
                        break;
                    case 2:
                        message.totalCount = reader.readInt32();
                        break;
                    case 3:
                        message.totalPages = reader.readInt32();
                        break;
                    case 4:
                        message.hasNext = reader.readBool();
                        break;
                    case 5:
                        message.hasPrev = reader.readBool();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): ListPlansResponse {
            return ListPlansResponse.deserialize(bytes);
        }
    }
    export class DeletePlanResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            success?: boolean;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("success" in data && data.success != undefined) {
                    this.success = data.success;
                }
            }
        }
        get success() {
            return pb_1.Message.getFieldWithDefault(this, 1, false) as boolean;
        }
        set success(value: boolean) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            success?: boolean;
        }): DeletePlanResponse {
            const message = new DeletePlanResponse({});
            if (data.success != null) {
                message.success = data.success;
            }
            return message;
        }
        toObject() {
            const data: {
                success?: boolean;
            } = {};
            if (this.success != null) {
                data.success = this.success;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.success != false)
                writer.writeBool(1, this.success);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): DeletePlanResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new DeletePlanResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.success = reader.readBool();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): DeletePlanResponse {
            return DeletePlanResponse.deserialize(bytes);
        }
    }
    export class UpdatePlanRequest extends pb_1.Message {
        #one_of_decls: number[][] = [[2], [3], [4], [5], [6], [9], [10], [11], [12], [14], [15], [16], [17], [18]];
        constructor(data?: any[] | ({
            id?: string;
            products?: PlanProdRequest[];
        } & (({
            name?: string;
        }) | ({
            description?: string;
        }) | ({
            price?: dependency_1.common.v1.Price;
        }) | ({
            cycle?: Cycle;
        }) | ({
            visibility?: Visibility;
        }) | ({
            paymentMethods?: PaymentMethod;
        }) | ({
            autoRenewal?: boolean;
        }) | ({
            maxChargeAttempts?: number;
        }) | ({
            overdueDays?: number;
        }) | ({
            trialDays?: number;
        }) | ({
            status?: Status;
        }) | ({
            mainAction?: boolean;
        }) | ({
            planType?: Type;
        }) | ({
            removeAds?: boolean;
        })))) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [7], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("id" in data && data.id != undefined) {
                    this.id = data.id;
                }
                if ("name" in data && data.name != undefined) {
                    this.name = data.name;
                }
                if ("description" in data && data.description != undefined) {
                    this.description = data.description;
                }
                if ("price" in data && data.price != undefined) {
                    this.price = data.price;
                }
                if ("cycle" in data && data.cycle != undefined) {
                    this.cycle = data.cycle;
                }
                if ("visibility" in data && data.visibility != undefined) {
                    this.visibility = data.visibility;
                }
                if ("products" in data && data.products != undefined) {
                    this.products = data.products;
                }
                if ("paymentMethods" in data && data.paymentMethods != undefined) {
                    this.paymentMethods = data.paymentMethods;
                }
                if ("autoRenewal" in data && data.autoRenewal != undefined) {
                    this.autoRenewal = data.autoRenewal;
                }
                if ("maxChargeAttempts" in data && data.maxChargeAttempts != undefined) {
                    this.maxChargeAttempts = data.maxChargeAttempts;
                }
                if ("overdueDays" in data && data.overdueDays != undefined) {
                    this.overdueDays = data.overdueDays;
                }
                if ("trialDays" in data && data.trialDays != undefined) {
                    this.trialDays = data.trialDays;
                }
                if ("status" in data && data.status != undefined) {
                    this.status = data.status;
                }
                if ("mainAction" in data && data.mainAction != undefined) {
                    this.mainAction = data.mainAction;
                }
                if ("planType" in data && data.planType != undefined) {
                    this.planType = data.planType;
                }
                if ("removeAds" in data && data.removeAds != undefined) {
                    this.removeAds = data.removeAds;
                }
            }
        }
        get id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get name() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set name(value: string) {
            pb_1.Message.setOneofField(this, 2, this.#one_of_decls[0], value);
        }
        get hasName() {
            return pb_1.Message.getField(this, 2) != null;
        }
        get description() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set description(value: string) {
            pb_1.Message.setOneofField(this, 3, this.#one_of_decls[1], value);
        }
        get hasDescription() {
            return pb_1.Message.getField(this, 3) != null;
        }
        get price() {
            return pb_1.Message.getWrapperField(this, dependency_1.common.v1.Price, 4) as dependency_1.common.v1.Price;
        }
        set price(value: dependency_1.common.v1.Price) {
            pb_1.Message.setOneofWrapperField(this, 4, this.#one_of_decls[2], value);
        }
        get hasPrice() {
            return pb_1.Message.getField(this, 4) != null;
        }
        get cycle() {
            return pb_1.Message.getFieldWithDefault(this, 5, Cycle.CYCLE_UNSPECIFIED) as Cycle;
        }
        set cycle(value: Cycle) {
            pb_1.Message.setOneofField(this, 5, this.#one_of_decls[3], value);
        }
        get hasCycle() {
            return pb_1.Message.getField(this, 5) != null;
        }
        get visibility() {
            return pb_1.Message.getFieldWithDefault(this, 6, Visibility.VISIBILITY_UNSPECIFIED) as Visibility;
        }
        set visibility(value: Visibility) {
            pb_1.Message.setOneofField(this, 6, this.#one_of_decls[4], value);
        }
        get hasVisibility() {
            return pb_1.Message.getField(this, 6) != null;
        }
        get products() {
            return pb_1.Message.getRepeatedWrapperField(this, PlanProdRequest, 7) as PlanProdRequest[];
        }
        set products(value: PlanProdRequest[]) {
            pb_1.Message.setRepeatedWrapperField(this, 7, value);
        }
        get paymentMethods() {
            return pb_1.Message.getWrapperField(this, PaymentMethod, 9) as PaymentMethod;
        }
        set paymentMethods(value: PaymentMethod) {
            pb_1.Message.setOneofWrapperField(this, 9, this.#one_of_decls[5], value);
        }
        get hasPaymentMethods() {
            return pb_1.Message.getField(this, 9) != null;
        }
        get autoRenewal() {
            return pb_1.Message.getFieldWithDefault(this, 10, false) as boolean;
        }
        set autoRenewal(value: boolean) {
            pb_1.Message.setOneofField(this, 10, this.#one_of_decls[6], value);
        }
        get hasAutoRenewal() {
            return pb_1.Message.getField(this, 10) != null;
        }
        get maxChargeAttempts() {
            return pb_1.Message.getFieldWithDefault(this, 11, 0) as number;
        }
        set maxChargeAttempts(value: number) {
            pb_1.Message.setOneofField(this, 11, this.#one_of_decls[7], value);
        }
        get hasMaxChargeAttempts() {
            return pb_1.Message.getField(this, 11) != null;
        }
        get overdueDays() {
            return pb_1.Message.getFieldWithDefault(this, 12, 0) as number;
        }
        set overdueDays(value: number) {
            pb_1.Message.setOneofField(this, 12, this.#one_of_decls[8], value);
        }
        get hasOverdueDays() {
            return pb_1.Message.getField(this, 12) != null;
        }
        get trialDays() {
            return pb_1.Message.getFieldWithDefault(this, 14, 0) as number;
        }
        set trialDays(value: number) {
            pb_1.Message.setOneofField(this, 14, this.#one_of_decls[9], value);
        }
        get hasTrialDays() {
            return pb_1.Message.getField(this, 14) != null;
        }
        get status() {
            return pb_1.Message.getFieldWithDefault(this, 15, Status.STATUS_UNSPECIFIED) as Status;
        }
        set status(value: Status) {
            pb_1.Message.setOneofField(this, 15, this.#one_of_decls[10], value);
        }
        get hasStatus() {
            return pb_1.Message.getField(this, 15) != null;
        }
        get mainAction() {
            return pb_1.Message.getFieldWithDefault(this, 16, false) as boolean;
        }
        set mainAction(value: boolean) {
            pb_1.Message.setOneofField(this, 16, this.#one_of_decls[11], value);
        }
        get hasMainAction() {
            return pb_1.Message.getField(this, 16) != null;
        }
        get planType() {
            return pb_1.Message.getFieldWithDefault(this, 17, Type.TYPE_UNSPECIFIED) as Type;
        }
        set planType(value: Type) {
            pb_1.Message.setOneofField(this, 17, this.#one_of_decls[12], value);
        }
        get hasPlanType() {
            return pb_1.Message.getField(this, 17) != null;
        }
        get removeAds() {
            return pb_1.Message.getFieldWithDefault(this, 18, false) as boolean;
        }
        set removeAds(value: boolean) {
            pb_1.Message.setOneofField(this, 18, this.#one_of_decls[13], value);
        }
        get hasRemoveAds() {
            return pb_1.Message.getField(this, 18) != null;
        }
        get _name() {
            const cases: {
                [index: number]: "none" | "name";
            } = {
                0: "none",
                2: "name"
            };
            return cases[pb_1.Message.computeOneofCase(this, [2])];
        }
        get _description() {
            const cases: {
                [index: number]: "none" | "description";
            } = {
                0: "none",
                3: "description"
            };
            return cases[pb_1.Message.computeOneofCase(this, [3])];
        }
        get _price() {
            const cases: {
                [index: number]: "none" | "price";
            } = {
                0: "none",
                4: "price"
            };
            return cases[pb_1.Message.computeOneofCase(this, [4])];
        }
        get _cycle() {
            const cases: {
                [index: number]: "none" | "cycle";
            } = {
                0: "none",
                5: "cycle"
            };
            return cases[pb_1.Message.computeOneofCase(this, [5])];
        }
        get _visibility() {
            const cases: {
                [index: number]: "none" | "visibility";
            } = {
                0: "none",
                6: "visibility"
            };
            return cases[pb_1.Message.computeOneofCase(this, [6])];
        }
        get _payment_methods() {
            const cases: {
                [index: number]: "none" | "paymentMethods";
            } = {
                0: "none",
                9: "paymentMethods"
            };
            return cases[pb_1.Message.computeOneofCase(this, [9])];
        }
        get _auto_renewal() {
            const cases: {
                [index: number]: "none" | "autoRenewal";
            } = {
                0: "none",
                10: "autoRenewal"
            };
            return cases[pb_1.Message.computeOneofCase(this, [10])];
        }
        get _max_charge_attempts() {
            const cases: {
                [index: number]: "none" | "maxChargeAttempts";
            } = {
                0: "none",
                11: "maxChargeAttempts"
            };
            return cases[pb_1.Message.computeOneofCase(this, [11])];
        }
        get _overdue_days() {
            const cases: {
                [index: number]: "none" | "overdueDays";
            } = {
                0: "none",
                12: "overdueDays"
            };
            return cases[pb_1.Message.computeOneofCase(this, [12])];
        }
        get _trial_days() {
            const cases: {
                [index: number]: "none" | "trialDays";
            } = {
                0: "none",
                14: "trialDays"
            };
            return cases[pb_1.Message.computeOneofCase(this, [14])];
        }
        get _status() {
            const cases: {
                [index: number]: "none" | "status";
            } = {
                0: "none",
                15: "status"
            };
            return cases[pb_1.Message.computeOneofCase(this, [15])];
        }
        get _main_action() {
            const cases: {
                [index: number]: "none" | "mainAction";
            } = {
                0: "none",
                16: "mainAction"
            };
            return cases[pb_1.Message.computeOneofCase(this, [16])];
        }
        get _plan_type() {
            const cases: {
                [index: number]: "none" | "planType";
            } = {
                0: "none",
                17: "planType"
            };
            return cases[pb_1.Message.computeOneofCase(this, [17])];
        }
        get _remove_ads() {
            const cases: {
                [index: number]: "none" | "removeAds";
            } = {
                0: "none",
                18: "removeAds"
            };
            return cases[pb_1.Message.computeOneofCase(this, [18])];
        }
        static fromObject(data: {
            id?: string;
            name?: string;
            description?: string;
            price?: ReturnType<typeof dependency_1.common.v1.Price.prototype.toObject>;
            cycle?: Cycle;
            visibility?: Visibility;
            products?: ReturnType<typeof PlanProdRequest.prototype.toObject>[];
            paymentMethods?: ReturnType<typeof PaymentMethod.prototype.toObject>;
            autoRenewal?: boolean;
            maxChargeAttempts?: number;
            overdueDays?: number;
            trialDays?: number;
            status?: Status;
            mainAction?: boolean;
            planType?: Type;
            removeAds?: boolean;
        }): UpdatePlanRequest {
            const message = new UpdatePlanRequest({});
            if (data.id != null) {
                message.id = data.id;
            }
            if (data.name != null) {
                message.name = data.name;
            }
            if (data.description != null) {
                message.description = data.description;
            }
            if (data.price != null) {
                message.price = dependency_1.common.v1.Price.fromObject(data.price);
            }
            if (data.cycle != null) {
                message.cycle = data.cycle;
            }
            if (data.visibility != null) {
                message.visibility = data.visibility;
            }
            if (data.products != null) {
                message.products = data.products.map(item => PlanProdRequest.fromObject(item));
            }
            if (data.paymentMethods != null) {
                message.paymentMethods = PaymentMethod.fromObject(data.paymentMethods);
            }
            if (data.autoRenewal != null) {
                message.autoRenewal = data.autoRenewal;
            }
            if (data.maxChargeAttempts != null) {
                message.maxChargeAttempts = data.maxChargeAttempts;
            }
            if (data.overdueDays != null) {
                message.overdueDays = data.overdueDays;
            }
            if (data.trialDays != null) {
                message.trialDays = data.trialDays;
            }
            if (data.status != null) {
                message.status = data.status;
            }
            if (data.mainAction != null) {
                message.mainAction = data.mainAction;
            }
            if (data.planType != null) {
                message.planType = data.planType;
            }
            if (data.removeAds != null) {
                message.removeAds = data.removeAds;
            }
            return message;
        }
        toObject() {
            const data: {
                id?: string;
                name?: string;
                description?: string;
                price?: ReturnType<typeof dependency_1.common.v1.Price.prototype.toObject>;
                cycle?: Cycle;
                visibility?: Visibility;
                products?: ReturnType<typeof PlanProdRequest.prototype.toObject>[];
                paymentMethods?: ReturnType<typeof PaymentMethod.prototype.toObject>;
                autoRenewal?: boolean;
                maxChargeAttempts?: number;
                overdueDays?: number;
                trialDays?: number;
                status?: Status;
                mainAction?: boolean;
                planType?: Type;
                removeAds?: boolean;
            } = {};
            if (this.id != null) {
                data.id = this.id;
            }
            if (this.name != null) {
                data.name = this.name;
            }
            if (this.description != null) {
                data.description = this.description;
            }
            if (this.price != null) {
                data.price = this.price.toObject();
            }
            if (this.cycle != null) {
                data.cycle = this.cycle;
            }
            if (this.visibility != null) {
                data.visibility = this.visibility;
            }
            if (this.products != null) {
                data.products = this.products.map((item: PlanProdRequest) => item.toObject());
            }
            if (this.paymentMethods != null) {
                data.paymentMethods = this.paymentMethods.toObject();
            }
            if (this.autoRenewal != null) {
                data.autoRenewal = this.autoRenewal;
            }
            if (this.maxChargeAttempts != null) {
                data.maxChargeAttempts = this.maxChargeAttempts;
            }
            if (this.overdueDays != null) {
                data.overdueDays = this.overdueDays;
            }
            if (this.trialDays != null) {
                data.trialDays = this.trialDays;
            }
            if (this.status != null) {
                data.status = this.status;
            }
            if (this.mainAction != null) {
                data.mainAction = this.mainAction;
            }
            if (this.planType != null) {
                data.planType = this.planType;
            }
            if (this.removeAds != null) {
                data.removeAds = this.removeAds;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.id.length)
                writer.writeString(1, this.id);
            if (this.hasName)
                writer.writeString(2, this.name);
            if (this.hasDescription)
                writer.writeString(3, this.description);
            if (this.hasPrice)
                writer.writeMessage(4, this.price, () => this.price.serialize(writer));
            if (this.hasCycle)
                writer.writeEnum(5, this.cycle);
            if (this.hasVisibility)
                writer.writeEnum(6, this.visibility);
            if (this.products.length)
                writer.writeRepeatedMessage(7, this.products, (item: PlanProdRequest) => item.serialize(writer));
            if (this.hasPaymentMethods)
                writer.writeMessage(9, this.paymentMethods, () => this.paymentMethods.serialize(writer));
            if (this.hasAutoRenewal)
                writer.writeBool(10, this.autoRenewal);
            if (this.hasMaxChargeAttempts)
                writer.writeInt32(11, this.maxChargeAttempts);
            if (this.hasOverdueDays)
                writer.writeInt32(12, this.overdueDays);
            if (this.hasTrialDays)
                writer.writeInt32(14, this.trialDays);
            if (this.hasStatus)
                writer.writeEnum(15, this.status);
            if (this.hasMainAction)
                writer.writeBool(16, this.mainAction);
            if (this.hasPlanType)
                writer.writeEnum(17, this.planType);
            if (this.hasRemoveAds)
                writer.writeBool(18, this.removeAds);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): UpdatePlanRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new UpdatePlanRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.id = reader.readString();
                        break;
                    case 2:
                        message.name = reader.readString();
                        break;
                    case 3:
                        message.description = reader.readString();
                        break;
                    case 4:
                        reader.readMessage(message.price, () => message.price = dependency_1.common.v1.Price.deserialize(reader));
                        break;
                    case 5:
                        message.cycle = reader.readEnum();
                        break;
                    case 6:
                        message.visibility = reader.readEnum();
                        break;
                    case 7:
                        reader.readMessage(message.products, () => pb_1.Message.addToRepeatedWrapperField(message, 7, PlanProdRequest.deserialize(reader), PlanProdRequest));
                        break;
                    case 9:
                        reader.readMessage(message.paymentMethods, () => message.paymentMethods = PaymentMethod.deserialize(reader));
                        break;
                    case 10:
                        message.autoRenewal = reader.readBool();
                        break;
                    case 11:
                        message.maxChargeAttempts = reader.readInt32();
                        break;
                    case 12:
                        message.overdueDays = reader.readInt32();
                        break;
                    case 14:
                        message.trialDays = reader.readInt32();
                        break;
                    case 15:
                        message.status = reader.readEnum();
                        break;
                    case 16:
                        message.mainAction = reader.readBool();
                        break;
                    case 17:
                        message.planType = reader.readEnum();
                        break;
                    case 18:
                        message.removeAds = reader.readBool();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): UpdatePlanRequest {
            return UpdatePlanRequest.deserialize(bytes);
        }
    }
    export class UpdatePlanResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            plan?: Plan;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("plan" in data && data.plan != undefined) {
                    this.plan = data.plan;
                }
            }
        }
        get plan() {
            return pb_1.Message.getWrapperField(this, Plan, 1) as Plan;
        }
        set plan(value: Plan) {
            pb_1.Message.setWrapperField(this, 1, value);
        }
        get hasPlan() {
            return pb_1.Message.getField(this, 1) != null;
        }
        static fromObject(data: {
            plan?: ReturnType<typeof Plan.prototype.toObject>;
        }): UpdatePlanResponse {
            const message = new UpdatePlanResponse({});
            if (data.plan != null) {
                message.plan = Plan.fromObject(data.plan);
            }
            return message;
        }
        toObject() {
            const data: {
                plan?: ReturnType<typeof Plan.prototype.toObject>;
            } = {};
            if (this.plan != null) {
                data.plan = this.plan.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasPlan)
                writer.writeMessage(1, this.plan, () => this.plan.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): UpdatePlanResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new UpdatePlanResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.plan, () => message.plan = Plan.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): UpdatePlanResponse {
            return UpdatePlanResponse.deserialize(bytes);
        }
    }
    export abstract class UnimplementedPlanServiceService {
        static definition = {
            CreatePlan: {
                path: "/plans.v1.PlanService/CreatePlan",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: CreatePlanRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => CreatePlanRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: CreatePlanResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => CreatePlanResponse.deserialize(new Uint8Array(bytes))
            },
            UpdatePlan: {
                path: "/plans.v1.PlanService/UpdatePlan",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: UpdatePlanRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => UpdatePlanRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: UpdatePlanResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => UpdatePlanResponse.deserialize(new Uint8Array(bytes))
            },
            GetPlan: {
                path: "/plans.v1.PlanService/GetPlan",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: GetPlanRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => GetPlanRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: GetPlanResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => GetPlanResponse.deserialize(new Uint8Array(bytes))
            },
            ListPlans: {
                path: "/plans.v1.PlanService/ListPlans",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: ListPlansRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => ListPlansRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: ListPlansResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => ListPlansResponse.deserialize(new Uint8Array(bytes))
            },
            DeletePlan: {
                path: "/plans.v1.PlanService/DeletePlan",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: DeletePlanRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => DeletePlanRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: DeletePlanResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => DeletePlanResponse.deserialize(new Uint8Array(bytes))
            }
        };
        [method: string]: grpc_1.UntypedHandleCall;
        abstract CreatePlan(call: grpc_1.ServerUnaryCall<CreatePlanRequest, CreatePlanResponse>, callback: grpc_1.sendUnaryData<CreatePlanResponse>): void;
        abstract UpdatePlan(call: grpc_1.ServerUnaryCall<UpdatePlanRequest, UpdatePlanResponse>, callback: grpc_1.sendUnaryData<UpdatePlanResponse>): void;
        abstract GetPlan(call: grpc_1.ServerUnaryCall<GetPlanRequest, GetPlanResponse>, callback: grpc_1.sendUnaryData<GetPlanResponse>): void;
        abstract ListPlans(call: grpc_1.ServerUnaryCall<ListPlansRequest, ListPlansResponse>, callback: grpc_1.sendUnaryData<ListPlansResponse>): void;
        abstract DeletePlan(call: grpc_1.ServerUnaryCall<DeletePlanRequest, DeletePlanResponse>, callback: grpc_1.sendUnaryData<DeletePlanResponse>): void;
    }
    export class PlanServiceClient {
        private _address: string;
        private _client: grpc_web_1.GrpcWebClientBase;
        constructor(address: string, credentials?: Object, options?: grpc_web_1.GrpcWebClientBaseOptions) {
            if (!options)
                options = {};
            options.format = options.format || "text";
            this._address = address;
            this._client = new grpc_web_1.GrpcWebClientBase(options);
        }
        private static CreatePlan = new grpc_web_1.MethodDescriptor<CreatePlanRequest, CreatePlanResponse>("/plans.v1.PlanService/CreatePlan", grpc_web_1.MethodType.UNARY, CreatePlanRequest, CreatePlanResponse, (message: CreatePlanRequest) => message.serialize(), CreatePlanResponse.deserialize);
        CreatePlan(message: CreatePlanRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<CreatePlanRequest, CreatePlanResponse>(this._address + "/plans.v1.PlanService/CreatePlan", message, metadata || {}, PlanServiceClient.CreatePlan);
        }
        private static UpdatePlan = new grpc_web_1.MethodDescriptor<UpdatePlanRequest, UpdatePlanResponse>("/plans.v1.PlanService/UpdatePlan", grpc_web_1.MethodType.UNARY, UpdatePlanRequest, UpdatePlanResponse, (message: UpdatePlanRequest) => message.serialize(), UpdatePlanResponse.deserialize);
        UpdatePlan(message: UpdatePlanRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<UpdatePlanRequest, UpdatePlanResponse>(this._address + "/plans.v1.PlanService/UpdatePlan", message, metadata || {}, PlanServiceClient.UpdatePlan);
        }
        private static GetPlan = new grpc_web_1.MethodDescriptor<GetPlanRequest, GetPlanResponse>("/plans.v1.PlanService/GetPlan", grpc_web_1.MethodType.UNARY, GetPlanRequest, GetPlanResponse, (message: GetPlanRequest) => message.serialize(), GetPlanResponse.deserialize);
        GetPlan(message: GetPlanRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<GetPlanRequest, GetPlanResponse>(this._address + "/plans.v1.PlanService/GetPlan", message, metadata || {}, PlanServiceClient.GetPlan);
        }
        private static ListPlans = new grpc_web_1.MethodDescriptor<ListPlansRequest, ListPlansResponse>("/plans.v1.PlanService/ListPlans", grpc_web_1.MethodType.UNARY, ListPlansRequest, ListPlansResponse, (message: ListPlansRequest) => message.serialize(), ListPlansResponse.deserialize);
        ListPlans(message: ListPlansRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<ListPlansRequest, ListPlansResponse>(this._address + "/plans.v1.PlanService/ListPlans", message, metadata || {}, PlanServiceClient.ListPlans);
        }
        private static DeletePlan = new grpc_web_1.MethodDescriptor<DeletePlanRequest, DeletePlanResponse>("/plans.v1.PlanService/DeletePlan", grpc_web_1.MethodType.UNARY, DeletePlanRequest, DeletePlanResponse, (message: DeletePlanRequest) => message.serialize(), DeletePlanResponse.deserialize);
        DeletePlan(message: DeletePlanRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<DeletePlanRequest, DeletePlanResponse>(this._address + "/plans.v1.PlanService/DeletePlan", message, metadata || {}, PlanServiceClient.DeletePlan);
        }
    }
}
